import type { FC } from 'react';
import type { TaskIndexProps } from '../../types';
import { observer } from 'mobx-react-lite';
import useRulePageMode from '../../hooks/useRulePageMode';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import tasksFormValidation from '../../utils/tasksFormValidation';
import { Box, Button, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

const VariantsEmptyState: FC<TaskIndexProps> = observer(({ indexTask }) => {
  const { isRead } = useRulePageMode();
  const tasksFormStore = useCurrentTasksFormStore();
  const addVariantOnTask = () => {
    tasksFormStore.addVariantOnTask(indexTask);
  };
  const { isAddTaskAvailable } = tasksFormValidation({ tasksForm: tasksFormStore.tasksForm, indexTask });

  const canAddVariant = !isAddTaskAvailable || isRead;

  return (
    <Box
      sx={(t) => ({
        display: 'flex',
        gap: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        width: '100%',
        border: `1px dashed ${isAddTaskAvailable ? t.palette.primary.main : t.palette.grey[400]}`,
        borderRadius: t.borderRadius.md,
      })}
    >
      <Button startIcon={<AddIcon />} variant="text" onClick={addVariantOnTask} disabled={canAddVariant}>
        Add variant
      </Button>
      <Typography
        variant="body2"
        sx={(t) => ({ color: isAddTaskAvailable ? t.palette.text.secondary : t.palette.grey[400] })}
      >
        Set up actions depending on condition’s value
      </Typography>
    </Box>
  );
});

export default VariantsEmptyState;
